/* ---------- Hero: the render itself, nearly the width of the screen ----------
   The original render is 1280px wide, so the frame stops at 96vw (and 90rem) rather than
   bleeding to the edges, where it would be stretched soft. The heading sits over its
   lower left on a shade; on phones it sits under the picture instead. */
.hero {
  position: relative;
  width: min(96vw, 90rem);
  margin: var(--sp-4) auto 0;
  overflow: hidden;
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
  background: var(--surface-dark);
}
.heroImage {
  display: block;
}
.heroShade {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(0deg, rgba(8, 11, 15, 0.92) 0%, rgba(8, 11, 15, 0.55) 45%, transparent 75%),
    linear-gradient(90deg, rgba(8, 11, 15, 0.55) 0%, transparent 60%);
}
.heroText {
  position: absolute;
  inset: auto 0 0;
  padding-bottom: var(--sp-12);
  color: var(--text-on-dark);
}
.heroText > * {
  max-width: 44rem;
}
.heroTitle {
  margin-top: var(--sp-5);
  font-size: clamp(2.2rem, 3vw + 1rem, 4rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
  color: #fff;
}
.heroLead {
  margin-top: var(--sp-4);
  font-size: var(--fs-md);
  color: var(--text-on-dark-muted);
}
.heroActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-4) var(--sp-8);
  margin-top: var(--sp-6);
}
.heroLink {
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.heroLink:hover {
  color: var(--accent-text);
}
/* Phones and tablets: the picture on its own, the heading under it. */
@media (max-width: 63.99rem) {
  .hero {
    overflow: visible;
    border-radius: 0;
    box-shadow: none;
    background: none;
  }
  .heroImage {
    border-radius: var(--radius-lg);
    overflow: hidden;
  }
  .heroShade {
    display: none;
  }
  .heroText {
    position: static;
    padding-block: var(--sp-6) var(--sp-4);
  }
}

/* ---------- A render beside its text ---------- */
.split {
  display: grid;
  gap: var(--sp-10);
  align-items: center;
}
.splitImage {
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
.splitText > h2 {
  margin: 0 0 var(--sp-5);
}
.splitText p {
  margin: 0 0 var(--sp-4);
  max-width: 36rem;
  color: var(--text);
}
/* The conditions one scene renders under, as tags between the two paragraphs. */
.conditions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin: var(--sp-2) 0 var(--sp-6);
  padding: 0;
  list-style: none;
}
.conditions li {
  padding: var(--sp-2) var(--sp-4);
  border: 1px solid var(--border-strong);
  border-radius: 999px;
  background: var(--surface-raised);
  color: var(--text-strong);
  font-size: var(--fs-sm);
  font-weight: 600;
}
@media (min-width: 64rem) {
  .split {
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
    gap: var(--sp-16);
  }
  /* The staging section mirrors the one before it: text left, render right. */
  .reverse {
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  }
  .reverse > :first-child {
    order: 2;
  }
}
